import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface BalanceteEnqueueResponse {
  requestId?: string;
  totalEmpresas?: number;
  empresaIds?: number[];
  error?: string;
}

export interface BalanceteRequestPayload {
  dataInicio: string;
  dataFim: string;
  contaInicial: number;
  contaFinal: number;
  empresaId?: number | null;
  empresaIds?: number[] | null;
}

@Injectable({
  providedIn: 'root'
})
export class BalanceteService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  /** Uma empresa, várias ou todas (sem empresaId). */
  requestBalancete(payload: BalanceteRequestPayload) {
    const body: Record<string, unknown> = {
      dataInicio: payload.dataInicio,
      dataFim: payload.dataFim,
      contaInicial: payload.contaInicial,
      contaFinal: payload.contaFinal
    };

    if (payload.empresaIds?.length) {
      body['empresaIds'] = payload.empresaIds.filter((id) => id > 0);
    } else if (payload.empresaId != null && payload.empresaId > 0) {
      body['empresaId'] = payload.empresaId;
    }

    return this.http.post<BalanceteEnqueueResponse>(
      `${this.serviceApi}/v1/dominio-reports/balancete-report`,
      body
    );
  }

  /** Grupo de empresas via planilha (POST multipart). */
  requestBalancetePorPlanilha(
    planilha: File,
    dataInicio: string,
    dataFim: string,
    contaInicial: number,
    contaFinal: number
  ) {
    const formData = new FormData();
    formData.append('planilha', planilha);
    formData.append('dataInicio', dataInicio);
    formData.append('dataFim', dataFim);
    formData.append('contaInicial', String(contaInicial));
    formData.append('contaFinal', String(contaFinal));
    return this.http.post<BalanceteEnqueueResponse>(
      `${this.serviceApi}/v1/dominio-reports/balancete-report/planilha`,
      formData
    );
  }
}
